import React from "react";
import {
  Grid,
  CardMedia,
  makeStyles,
  createStyles,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
// import { Editor } from "react-draft-wysiwyg";

import sanitizeHtml from "sanitize-html";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalSector: {
      marginTop: "8%",
      display: "flex",
      fontFamily: "Noto Sans Kr",
      [theme.breakpoints.down("xs")]: { marginTop: 0 },
    },
    leftDivSector: { paddingRight: "6rem" },

    aspectRatioBox: {
      height: 0,
      paddingTop: "calc(591.44px / 1127.34px * 100%)",
      backgroundColor: "#FFC007",
      position: "relative",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    fireboxCentering: {
      // width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    viewPortSizing: {
      fontSize: "5vw",
      // zIndex: 0,
    },
    tuneWinnerCategory: {
      fontSize: 16,
      fontWeight: 900,
      color: "black",
      fontFamily: "Noto Sans Kr",
    },
    tuneWinnerTitle: {
      marginTop: 16,
      fontSize: 48,
      fontWeight: 500,
      color: "black",
      fontFamily: "Noto Sans Kr",
      letterSpacing: -2,
      marginLeft: -5,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 16,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: "black",
      fontFamily: "Noto Sans Kr",
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: "black",
      fontFamily: "Noto Sans Kr",
      lineHeight: 1.5,
    },
    winnerTopDiv: {
      //   display: "flex",
      // paddingBottom: 32,
    },
    storyText: {
      color: "black",
      paddingTop: "3rem",
      lineHeight: 1.5,
    },
    likeImg: {
      // backgroundColor: "#F6D300",
    },
    likeImgTitle: {
      // color: "#1dacd6",
      color: "#0f4c81",
      // color: "#418FDE",
      textAlign: "center",
      fontSize: 48,
      // fontWeight: 900,
      // fontFamily: "Gothic A1",
      fontFamily: `"62570체"`,
      paddingBottom: 56,
    },
    likeImgSubtilte: {
      fontFamily: "Noto Serif KR",
      fontWeight: 900,
      fontSize: 48,
      color: "#fff",
      textAlign: "center",
    },
  })
);

interface AspectDivProps {
  children: React.ReactNode;
}
function AspectDiv(props: AspectDivProps) {
  const classes = useStyles();

  return (
    <div className={classes.aspectRatioBox}>
      <div className={classes.aspectRatioBoxInside}>
        <div className={classes.fireboxCentering}>
          <div className={classes.viewPortSizing}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

interface ConcertDescribeSectionProps {
  image: React.ReactNode;
  // describe: React.ReactNode;
  content: any | string | null;
}

function ConcertDescribeSection({
  image,
  content,
}: ConcertDescribeSectionProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const defaultOptions = {
    allowedTags: [
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "main",
      "ol",
      "p",
      "pre",
      "ul",
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr",
      "img",
      "oembed",
    ],
    allowedClasses: {
      p: ["fancy", "simple", "media"],
      figure: ["image", "media"],
    },
    allowedAttributes: {
      a: ["href", "name", "target"],
      figure: ["class"],
      img: ["src", "class"],
      li: ["class"],
      oembed: ["url", "class"],
      // img: ["img"],
    },
    allowedSchemes: ["http", "https", "ftp", "mailto"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowedIframeHostnames: ["www.youtube.com"],
  };

  const sanitize = (dirty: any, options: any) => ({
    __html: sanitizeHtml(
      dirty,
      { ...defaultOptions, ...options }
      // options: { ...defaultOptions, ...options }
    ),
  });

  const SanitizeHTML = ({ html, options }: any) => (
    <div dangerouslySetInnerHTML={sanitize(html, options)} />
  );

  return (
    <Grid xs={12} className={classes.totalSector} item>
      {!matches ? (
        <Grid xs={7} item className={classes.leftDivSector}>
          {/* <AspectDiv>{image}</AspectDiv> */}
          <div
            style={{
              // backgroundColor: "red",
              position: "relative",
              width: "100%",
              paddingTop: "56.25%" /* 16:9 Aspect Ratio */,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                textAlign: "center",
                fontSize: 20,
                color: "white",
                backgroundImage: `url(${image})`,
                backgroundSize: "100%",
              }}
            ></div>
          </div>
        </Grid>
      ) : null}

      <Grid xs={!matches ? 5 : 12} item>
        <div className={classes.winnerDiv}>
          <div className={classes.winnerTopDiv}>
            <Grid xs={12} item>
              <SanitizeHTML html={`${content}`} />
              {/* <PageStylingDraftJS content={content} /> */}
            </Grid>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default ConcertDescribeSection;
